import React from 'react';
import PropTypes from 'prop-types';

import styles from './FlashMessage.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class FlashMessage extends React.PureComponent {
  render() {
    const {
      type,
      msgId,
      msgValues,
      location,
      animationType,
      dialog,
      errorCode,
    } = this.props;

    if (location === 'hidden') return null;

    const animationClass =
      animationType === 'fade' ? ' FlashMessage--fade-out' : '';
    const text = msgId ? (
      <ConnectedFormattedMessage
        id={msgId}
        values={msgValues}
        allowNullResponse
      />
    ) : (
      this.props.text
    );
    return (
      <div
        className={`FlashMessage FlashMessage--${type} FlashMessage--${location}${animationClass}`}
      >
        <div className="FlashMessage__content">{text}</div>
        {errorCode && type !== 'reconciliation' ? (
          <div className="FlashMessage__code">#{errorCode}</div>
        ) : null}
        {type === 'reconciliation' ? dialog : null}
      </div>
    );
  }
}

FlashMessage.propTypes = {
  /** Determines the style (and meaning) of the message */
  type: PropTypes.oneOf(['info', 'success', 'error', 'reconciliation']),
  /** If the ID is present, this is used to get the localized string */
  msgId: PropTypes.string,
  /** If the localized message has variables, they’re included here. */
  msgValues: PropTypes.object,
  /**
   * If the ID is not present, we can still accept a text string or
   * React element.
   */
  text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  /**
   * Flash messages are almost always absolutely positioned relative
   * to their parent element. This determines the offset.
   */
  location: PropTypes.oneOf([
    'container-header',
    'fixed-top',
    'inline-form',
    'content-frame',
    'lightbox-internal',
    'lightbox-create-class',
    'page-top',
    'user-list-header',
    'users-page-header',
    'hidden',
  ]),
  /**
   * Most messages fade out (after 4 seconds), but it’s possible for
   * them to stick around until being cleared.
   */
  animationType: PropTypes.oneOf(['fade', 'persist']),
  /** Rarely, a form requires a true/false dialog after submission. */
  dialog: PropTypes.element,
  /** For error messages, we display the numberical error code. */
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

FlashMessage.defaultProps = {
  type: 'info',
  location: 'page-top',
};

export default FlashMessage;
